/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FxIdDomainSettingsWebRuntimeType {
    Desktop = 0,
    Android = 1,
    IPhone = 2,
    IPad = 3,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainSettingsWebRuntimeType(value: any): boolean {
    for (const key in FxIdDomainSettingsWebRuntimeType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainSettingsWebRuntimeType, key)) {
            if (FxIdDomainSettingsWebRuntimeType[key as keyof typeof FxIdDomainSettingsWebRuntimeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainSettingsWebRuntimeTypeFromJSON(json: any): FxIdDomainSettingsWebRuntimeType {
    return FxIdDomainSettingsWebRuntimeTypeFromJSONTyped(json, false);
}

export function FxIdDomainSettingsWebRuntimeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsWebRuntimeType {
    return json as FxIdDomainSettingsWebRuntimeType;
}

export function FxIdDomainSettingsWebRuntimeTypeToJSON(value?: FxIdDomainSettingsWebRuntimeType | null): any {
    return value as any;
}

export function FxIdDomainSettingsWebRuntimeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainSettingsWebRuntimeType {
    return value as FxIdDomainSettingsWebRuntimeType;
}

